/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForPatchManagementAzure extends models.GovernanceConfigurationBaseForOperations {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForPatchManagementAzure");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForPatchManagementAzure.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForPatchManagementAzure>): GovernanceConfigurationForPatchManagementAzure {
        let obj = Object.assign(new GovernanceConfigurationForPatchManagementAzure(), model);
        GovernanceConfigurationForPatchManagementAzure.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForPatchManagementAzure>): GovernanceConfigurationForPatchManagementAzure {
        if (!model) return null;
        return GovernanceConfigurationForPatchManagementAzure.newInstance(<GovernanceConfigurationForPatchManagementAzure> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForPatchManagementAzure) {
        if (!obj) return;

        models.GovernanceConfigurationForPatchManagementAzure.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForPatchManagementAzure): boolean {
        if (models.GovernanceConfigurationBaseForOperations.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForPatchManagementAzure.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Specifies whether patch management configuration enabled or not
     */
    enabled: boolean;

}
